import { MicrosoftAuth } from '../../../services/auth/microsoft/microsoft'
import { SlackAuth } from '../../../services/auth/slack/slack'
import { GoogleAuth } from '../../../services/auth/google/google'
import { BrowserRuntimeV2 } from '../../../util/openid/browser-runtime-v2'

if (!process.env.REACT_APP_MICROSOFT_CLIENT_ID || !process.env.REACT_APP_SLACK_CLIENT_ID || !process.env.REACT_APP_GOOGLE_CLIENT_ID) {
  throw new Error('Client ID are required')
}

// One instance per client for the lifetime of the tab: they hold the tokens the OAuth popups
// write back, so rebuilding them per render would drop an in-flight sign-up.
export const msAuth = new MicrosoftAuth(process.env.REACT_APP_MICROSOFT_CLIENT_ID, BrowserRuntimeV2())
export const slackAuth = new SlackAuth(process.env.REACT_APP_SLACK_CLIENT_ID, BrowserRuntimeV2())
export const googleAuth = new GoogleAuth(process.env.REACT_APP_GOOGLE_CLIENT_ID, BrowserRuntimeV2())
